import React from 'react'
import _ from 'lodash'

import withEventEmitter from '../../../hoc/withEventEmitter'
import { Events } from 'constants/event'
import { Button, Text } from '@wework/dieter-ui'
import Note from 'components/SidebarBlocks/Note'

const SpaceOfficeNote = props => {
  const { space, editable, maxCharacter, onClickEdit, emitUserEvent } = props

  let officeNote = ''

  const { reservable } = space

  if (!reservable) {
    return null
  }

  const note = _.get(reservable, 'note')
  const hasNote = note && note.trim() !== '0'

  if (!editable && !hasNote) {
    return null
  }

  if (hasNote) {
    officeNote = note
    if (
      maxCharacter &&
      typeof maxCharacter === 'number' &&
      officeNote.length > maxCharacter
    ) {
      officeNote = `${officeNote.substring(0, maxCharacter)}...`
    }
  }

  let noteAction
  if (editable) {
    const textAlign = hasNote ? 'right' : 'left'
    const buttonText = hasNote ? 'Edit note' : 'Add a note'
    noteAction = (
      <div style={{ marginTop: 18, textAlign }}>
        <Button
          data-testid="open-office-note-modal"
          // size="small"
          size="small"
          primary
          onClick={() => {
            emitUserEvent(
              hasNote
                ? Events.SPACE_CLICK_UPDATE_OFFICE_NOTE
                : Events.SPACE_CLICK_ADD_OFFICE_NOTE,
              {}
            )
            onClickEdit()
          }}
        >
          {buttonText}
        </Button>
      </div>
    )
  }

  return (
    <div
      style={{
        padding: 16,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: '#E6E6E6',
      }}
    >
      <Note />
      {/* <Text size="small" style={{ fontWeight: 'bold' }}>
        Note
      </Text>
      <div style={{ fontWeight: 'light', fontSize: '1rem' }}>
        <Text
          className={classes.noteText}
          gutterBottom
          data-testid="office-note"
        >
          {hasNote &&
            officeNote.split('\n').map((text, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <Text key={index} size="small">
                  {text}
                  <br />
                </Text>
              )
            })}
        </Text>
      </div>
      {noteAction} */}
    </div>
  )
}

SpaceOfficeNote.defaultProps = {
  editable: false,
}

export default withEventEmitter()(SpaceOfficeNote)
